module.exports = __webpack_public_path__ + "img/Rectangle 748 (1).af219ef7.png";